import { baseURL } from '../config'

interface UniResponse {
  statusCode: number
  data: {
    code: number
    msg: string
    data: any
  }
}

interface RequestOptions {
  url: string
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
  data?: any
  params?: Record<string, any>
  header?: Record<string, string>
}

class Http {
  private static instance: Http
  private baseURL: string
  private timeout: number

  private constructor() {
    this.baseURL = baseURL
    this.timeout = 10000
  }

  public static getInstance(): Http {
    if (!Http.instance) {
      Http.instance = new Http()
    }
    return Http.instance
  }

  private getToken(): string {
    return uni.getStorageSync('token') || ''
  }

  private handleResponse(response: UniResponse): any {
    if (response.statusCode === 200) {
      const { code, msg, data } = response.data
      if (code === 0) {
        return { code, msg, data }
      } else {
        uni.showToast({
          title: msg || '请求失败',
          icon: 'none'
        })
        return Promise.reject(new Error(msg))
      }
    } else {
      uni.showToast({
        title: '网络错误',
        icon: 'none'
      })
      return Promise.reject(new Error('网络错误'))
    }
  }

  private handleError(error: Error): Promise<never> {
    uni.showToast({
      title: error.message || '请求失败',
      icon: 'none'
    })
    return Promise.reject(error)
  }

  public async request(options: RequestOptions): Promise<any> {
    const token = this.getToken()
    const header = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
      ...options.header
    }

    // 处理 GET 请求的查询参数
    let url = options.url
    if (options.params) {
      const query = Object.entries(options.params)
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
        .join('&')
      url += (url.includes('?') ? '&' : '?') + query
    }

    return new Promise((resolve, reject) => {
      uni.request({
        url: this.baseURL + url,
        method: options.method || 'GET',
        data: options.data,
        header,
        timeout: this.timeout,
        success: (res) => {
          resolve(this.handleResponse(res))
        },
        fail: (err) => {
          reject(this.handleError(err))
        }
      })
    })
  }

  public get(url: string, params?: Record<string, any>, header?: Record<string, string>) {
    return this.request({ url, method: 'GET', params, header })
  }

  public post(url: string, data?: any, header?: Record<string, string>) {
    return this.request({ url, method: 'POST', data, header })
  }

  public put(url: string, data?: any, header?: Record<string, string>) {
    return this.request({ url, method: 'PUT', data, header })
  }

  public delete(url: string, data?: any, header?: Record<string, string>) {
    return this.request({ url, method: 'DELETE', data, header })
  }
}

export const http = Http.getInstance()
export default http 